<template>
  <cms-block
    :identifier="blockIdentifier"
    :lazy="lazy"
  />
</template>

<script>
import CmsBlock from 'theme/components/core/blocks/Cms/Block'

export default {
  name: 'EvCategoryBlock',
  components: {
    CmsBlock
  },
  props: {
    blockIdentifier: {
      type: String
    },
    lazy: {
      type: Boolean,
      default: false,
      required: false
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~theme/css/variables/grid';
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';

/deep/ {
  .recommended-events,
  .popular-categories {
    p {
      margin: 0;
    }

    ul {
      list-style: none;
    }

    @include mobile {
      .category-name-heading {
        font-size: 15px;
        line-height: 18px;
        margin-top: 2px;
      }

      .recommended-event-category-title {
        margin-top: 5px;
        margin-bottom: 5px;
        font-size: 18px;
        line-height: 27px;
      }
    }

    @include tablet {
      h2 {
        margin-top: 20px;
        margin-bottom: 5px;
      }

      .popular-categories-description,
      .category-name-heading {
        font-size: 15px;
        line-height: 18px;
      }

      .category-name-heading {
        margin-top: 20px;
        margin-bottom: 5px;
      }

      .categories-wrapper {
        padding: 0 20px;
      }
    }

    @include desktop {
      h2 {
        margin-bottom: 5px;
        font-size: 40px;
        line-height: 48px;
      }

      .popular-categories-description,
      .category-name-heading {
        font-size: 24px;
        line-height: 29px;
      }

      .category-name-heading {
        margin-top: 40px;
        margin-bottom: 5px;
      }
    }

    li {
      a {
        border-radius: 10px;

        &:hover,
        &:focus {
          h6 {
            color: color(primary);
          }
        }
      }
    }

    .image-wrapper {
      img {
        border-radius: 10px;
      }
    }
  }

  .popular-categories {
    li {
      .image-wrapper {
        padding-bottom: 118%;

        img {
          object-fit: cover;
        }
      }

      &:nth-child(even) {
        a {
          margin-left: 8px;
        }
      }

      &:nth-child(odd) {
        a {
          margin-right: 8px;
        }
      }
    }

    @include tablet {
      padding: 0 10px;

      li {
        &:nth-child(odd),
        &:nth-child(even) {
          a {
            margin-left: 0;
            margin-right: 8px;
          }
        }
      }
    }

    @include desktop {
      padding: 0 85px 3px 85px;

      h2 {
        text-align: left;
        margin-top: 40px;
        font-size: 40px;
        line-height: 48px;
      }

      li {
        max-width: 307px;

        &:nth-child(odd),
        &:nth-child(even) {
          a {
            margin-left: 0;
            margin-right: 8px;
          }
        }

        h6 {
          margin-top: 5px;
        }
      }

      a {
        max-width: 272px;
        padding: 10px 16px;
      }

      .event-count {
        font-size: 18px;
        margin-top: 10px;
        margin-bottom: 3px;
      }
    }
  }

  .recommended-events {
    li {
      margin-bottom: 13px;
      flex: 0 1 auto;
      max-width: none;

      a {
        padding: 0;
        text-align: left;
      }
    }

    .image-wrapper {
      overflow: hidden;

      img {
        object-fit: cover;
        object-position: top;
      }
    }

    @include mobile {
      padding: 0 10px;
      padding-right: 0;

      ul {
        flex-wrap: nowrap;
        overflow-x: auto;
        scrollbar-width: none;
        gap: 10px;
      }

      .image-wrapper {
        height: 120px;
        width: 160px;
      }

      .categories-wrapper {
        padding-right: 0;
      }

      h2 {
        text-align: left;
        padding-left: 10px;
        margin-bottom: 5px;
      }

      h3 {
        display: block;
        font-size: 15px !important;
        line-height: 18px !important;
        padding-left: 10px;
      }
    }

    @include mediaQuery(sm, null) {
      li {
        max-width: calc((100% - 4 * 20px) / 5);
        margin-right: 20px;

        &:last-child {
          margin-right: 0;
        }

        &:nth-child(5) {
          margin-right: 0;
        }

        &:nth-child(6) {
          display: none;
        }
      }

      .image-wrapper {
        aspect-ratio: 4 / 3;
        overflow: hidden;
      }
    }

    @include tablet {
      .recommended-events-description {
        font-size: 15px;
        line-height: 18px;
      }

      .recommended-event-category-title {
        font-size: 18px;
        line-height: 18px;
        margin-top: 9px;
        margin-bottom: 5px;
      }
    }

    @include desktop {
      h2 {
        margin-top: 19px;
      }

      .container {
        &.px20 {
          padding-left: 85px;
          padding-right: 85px;
        }
      }

      .categories-wrapper {
        &.px10 {
          padding-left: 85px;
          padding-right: 85px;
        }
      }

      .recommended-events-description {
        font-size: 24px;
        line-height: 29px;
      }

      .recommended-event-category-title {
        margin-top: 9px;
        margin-bottom: 5px;
        font-size: 24px;
        line-height: 29px;
      }
    }
  }
}
</style>
